const CATEGORIES = [
  {
    title: "Boutique hotels",
    line: "Suite reveals, lobby films, breakfast moments.",
    image:
      "https://images.unsplash.com/photo-1621293954908-907159247fc8?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
  },
  {
    title: "Aesthetic clinics",
    line: "Treatment day-in-life, before/after, walk-throughs.",
    image:
      "https://images.unsplash.com/photo-1762625570087-6d98fca29531?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
  },
  {
    title: "Restaurants & cafés",
    line: "Tasting menus, chef stories, ambience cuts.",
    image:
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
  },
  {
    title: "Retail & flagship",
    line: "Drop launches, in-store haul, fitting-room cuts.",
    image:
      "https://images.unsplash.com/photo-1567401893414-76b7b1e5a7a5?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
  },
];

export default function TargetAudience() {
  return (
    <section
      id="brands"
      data-testid="target-audience-section"
      className="py-24 sm:py-32 bg-white border-y border-[#B1B7AB]/40"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-6">
            <p className="text-xs uppercase tracking-[0.22em] text-[#276152] font-semibold">
              Built for
            </p>
            <h2 className="font-serif text-5xl sm:text-6xl leading-[0.95] mt-4 text-[#0D3A35]">
              Physical-place
              <br />
              <span className="text-[#276152]">brands.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 self-end">
            <p className="text-lg leading-relaxed text-[#0D3A35]/75">
              Lychee isn&apos;t a marketplace and isn&apos;t for e-com. It&apos;s for
              brands with a venue, a door, and a story that lives inside four
              walls.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {CATEGORIES.map((c, i) => (
            <article
              key={c.title}
              data-testid={`category-${c.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`group relative rounded-2xl overflow-hidden bg-[#0D3A35] aspect-[16/10] ${
                i % 2 === 0 ? "md:translate-y-0" : "md:translate-y-10"
              }`}
            >
              <img
                src={c.image}
                alt={c.title}
                className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-700 ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0D3A35]/85 via-[#0D3A35]/20 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-8 lg:p-10">
                <h3 className="font-serif text-4xl text-[#FFFFFF] leading-none">
                  {c.title}
                </h3>
                <p className="mt-2 text-sm text-[#FFFFFF]/85 max-w-md">
                  {c.line}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
